var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col h-full"},[_vm._t("default"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.current),expression:"current"}],staticClass:"flex-shrink-0 text-right text-xs",class:{
            'text-red-500': _vm.current > _vm.limit,
            'text-gray-500': _vm.current <= _vm.limit,
        }},[_vm._v(_vm._s(_vm.$t('components.textareaLimit', [_vm.current, _vm.limit])))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }